<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="ecommerce-application">
            <div class="" *ngIf="challanHistory?.length != 0">
                <section class="row match-height">
                    <div class="col-12 col-md-3 col-lg-3 p-0-10" *ngFor="let challan of challanHistory;let i=index;">
                        <div class="card pt-1 card-border">
                            <div class="card-body p-0-10 text-center">
                                <h4 class="item-name">
                                    <b>{{ 'CHALLAN_ID' | translate }} </b> : #{{ challan.invoice_no }}
                                </h4>
                                <p class="card-text item-description ">
                                    <b>{{ 'DATE' | translate }}</b> : {{ challan.delivery_date }}
                                </p>
                                <p class="card-text item-description">
                                    <b>{{ 'AMOUNT' | translate }}</b> : ₹ {{ challan.delivery_amount }}
                                </p>
                                <div class="row">
                                    <div class="col-12 p-0 pl-4px pr-4px">
                                        <a class="btn btn-primary btn-block  br-0 bbrr-5px" (click)="modalOpen(modalBasic,i)" rippleEffec>
                                            <i data-feather="eye" class="mr-25"></i>
                                            <span class="add-to-cart">{{ 'VIEW_DETAIL' | translate }}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col text-center" *ngIf="challanHistory?.length == 0">
                <div class="loader mt-2" *ngIf="loading">
                    <img src="assets/images/loder.gif" />
                    <p class="card-text">{{ 'PLEASE_WAIT_LOADING' | translate }}</p>
                </div>
                <div class="unauthorized-access mt-2" *ngIf="!loading">
                    <img src="assets/images/nodata.png" />
                    <p class="card-text">{{ 'NO_DATA_FOUND' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<ng-template #modalBasic let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1" *ngIf="challandetails?.length != 0">{{ 'CHALLAN_ID' | translate }} : #{{challandetails.invoice_no }}</h4>
        <h4 class="modal-title" id="myModalLabel1" *ngIf="challandetails?.length == 0">{{ 'CHALLAN_DETAILS' | translate }}</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="col" *ngIf="challandetails?.length == 0">
            <div class="text-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ 'LOADING' | translate }}</span>
                </div>
                <div>
                    {{ 'PLEASE_WAIT_SMALL' | translate }}
                </div>
            </div>
        </div>
        <div class="row" *ngIf="challandetails?.length != 0">
            <div class="col-12 text-right mb-1"><b>{{ 'DATE' | translate }}: {{challandetails.delivery_date}}</b></div>
            <div class="col-12 p-0 table-reposive overflow-auto">
                <table class="table table-bordered order-details-table">
                    <tr>
                        <th>{{ 'DESCRIPTION' | translate }}</th>
                        <th>{{ 'RATE' | translate }}</th>
                        <th>{{ 'QTY' | translate }}</th>
                        <th>{{ 'TOTAL' | translate }}</th>
                    </tr>
                    <tr *ngFor="let detail of challandetails.dispatch_products;">
                        <td>{{ detail.product_code }} {{ detail.product_name }} {{ detail.size_title }} {{ detail.color_title }} </td>
                        <td>{{ detail.dispatch_price }}</td>
                        <td>{{ detail.dispatch_qty }}</td>
                        <td class="text-right">₹ {{ detail.dispatch_sub_total }}</td>
                    </tr>
                    <tr *ngIf="challandetails.delivery_sub_total > 0">
                        <td class="text-right" colspan="3">{{ 'SUB_TOTAL' | translate }}</td>
                        <td class="text-right">₹ {{ challandetails.delivery_sub_total }}</td>
                    </tr>
                    <tr *ngIf="challandetails.discount_rs > 0">
                        <td class="text-right" colspan="3">{{ 'DISCOUNT' | translate }} ( {{ challandetails.discount_pre }}% )</td>
                        <td class="text-right">₹ {{ challandetails.discount_rs }}</td>
                    </tr>
                    <tr *ngIf="challandetails.tax_one_rs > 0">
                        <td class="text-right" colspan="3">{{ challandetails.tax_one }} ( {{ challandetails.tax_one_pre }}% )</td>
                        <td class="text-right">₹ {{ challandetails.tax_one_rs }}</td>
                    </tr>
                    <tr *ngIf="challandetails.tax_two_rs > 0">
                        <td class="text-right" colspan="3">{{ challandetails.tax_two }} ( {{ challandetails.tax_two_pre }}% )</td>
                        <td class="text-right">₹ {{ challandetails.tax_two_rs }}</td>
                    </tr>
                    <tr *ngIf="challandetails.round_off > 0">
                        <td class="text-right" colspan="3">{{ 'ROUND_OFF' | translate }}</td>
                        <td class="text-right">₹ {{ challandetails.round_off }}</td>
                    </tr>
                    <tr *ngIf="challandetails.delivery_amount > 0">
                        <th class="text-right" colspan="3">{{ 'GRAND_TOTAL' | translate }}</th>
                        <th class="text-right">₹ {{ challandetails.delivery_amount }}</th>
                    </tr>
                </table>

                <table class="table table-bordered order-details-table">
                    <tr>
                        <td colspan="2" class="text-center">
                            <h3>{{ 'TRANSPORT_DETAILS' | translate }}</h3>
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{ 'LR_NO' | translate }} :</b> <br/> &nbsp; &nbsp; {{ challandetails.lr_no }}</td>
                        <td><b>{{ 'TRANSPORT_NAME' | translate }} :</b><br> &nbsp; &nbsp; {{ challandetails.transport_name }}</td>
                    </tr>
                    <tr>
                        <td><b>{{ 'VEHICLE_NO' | translate }} :</b><br/> &nbsp; &nbsp; {{ challandetails.vehicle_no }}</td>
                        <td><b>{{ 'MOBILE' | translate }} :</b><br/> &nbsp; &nbsp; {{ challandetails.mobile }}</td>
                    </tr>
                    <tr>
                        <th>{{ 'REMARK' | translate }} :</th>
                        <td>{{ challandetails.remarks }}</td>
                    </tr>

                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')" rippleEffect>
            {{ 'CLOSE' | translate }}
    </button>
    </div>
</ng-template>
<!-- / Modal -->